export default function ProductFeatures({ product }) {
  const features = product.features || [];
  if (features.length === 0) return null;
  return (
    <section className="product-block">
      <div className="product-block__head">/ Key features</div>
      <h4 className="product-block__title">What you get</h4>
      <div className="product-features">
        {features.map((f, i) => (
          <div key={i} className="product-feature">
            <div className="product-feature__index">/ {String(i + 1).padStart(2, '0')}</div>
            <h4>{f.title}</h4>
            <p>{f.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
